<template>
  <div
    class="step-bar"
  >
    <step-item
      v-for="(step, index) in steps"
      :key="index"
      :label="step.label"
      :completed="step.completed"
      :isCurrent="step.isCurrent"
      @click="$emit('step-click', index)"
      :image-url="commonImage"
      :disabled="disabled"
    ></step-item>
  </div>
</template>
<script>
import StepItem from "./stepItem.vue";
export default {
  name: "StepBar",
  components: { StepItem },
  props: {
    steps: {
      type: Array,
      required: true,
    },
    commonImage: { type: String, default: "" },
    disabled: { type: Boolean, default: false },
  },
  mounted() {
    console.log("disabled",this.disabled)
  }
};
</script>

<style scoped>
.step-bar {
  display: flex;
  width: 100%;
  gap: 10px;
}

</style>
